/**
 * Wireframe X2 note 1 — a filename too long for its row should keep its
 * extension visible (`Quotation_Staples…Jul26.pdf`), not lose it to CSS's
 * trailing `text-overflow: ellipsis`, which chops the tail — extension
 * included — off whatever does not fit. CSS has no middle-truncation mode of
 * its own, so this runs once, in JS, before the string ever reaches the DOM.
 *
 * `maxLength` counts the whole displayed string, ellipsis included. The
 * extension (from the last `.`, when there is one that is not the first or
 * last character) is always kept whole; the remaining budget is split
 * between the start and end of the base name.
 */
const ELLIPSIS = '…';

export function truncateFileNameMiddle(fileName: string, maxLength = 28): string {
  if (fileName.length <= maxLength) return fileName;

  const dotIndex = fileName.lastIndexOf('.');
  const hasExtension = dotIndex > 0 && dotIndex < fileName.length - 1;
  const extension = hasExtension ? fileName.slice(dotIndex) : '';
  const base = hasExtension ? fileName.slice(0, dotIndex) : fileName;

  const available = maxLength - extension.length - ELLIPSIS.length;
  if (available <= 0) {
    // Nothing left for the base name at all — the extension alone already
    // fills the budget. Still better than an empty string.
    return `${ELLIPSIS}${extension}`;
  }

  const headLength = Math.ceil(available / 2);
  const tailLength = Math.floor(available / 2);
  const head = base.slice(0, headLength);
  const tail = tailLength > 0 ? base.slice(Math.max(0, base.length - tailLength)) : '';

  return `${head}${ELLIPSIS}${tail}${extension}`;
}
